'use strict'

const CENTURY_TOKEN = '-'

module.exports = {
  date: function (inputDate) {
    var day = null,
      month = null,
      year = null,
      century = ''

      ;[day, month, year] = inputDate.replace(/[-\/]/g, ' ').split(' ')

    ;[day, month, year].forEach(function (e) {
      if (isNaN(parseInt(e, 10))) {
        throw 'Expected a number, found "' + e + '"'
      }
    })

    if (day < 1 || day > 31) {
      throw 'Day must be between 1 and 31, found "' + day + '"'
    }
    if (month < 1 || month > 12) {
      throw 'Month must be between 1 and 12, found "' + month + '"'
    }

    while (year.length > 2) {
      year = year.toString().split('')
      century += year.shift()
      year = year.join('')
    }

    if (year < 0 || year > 99) {
      throw 'Year must be between 0 and 99, found "' + year + '"'
    }
    if (century < -20 || century > 21) {
      throw 'Century must be between -20 and 21, found "' + year + '"'
    }

    // remove leading zeroes
    day = parseInt(day).toString()
    month = parseInt(month).toString()
    year = parseInt(year).toString()

    if (century.length > 0) {
      century = CENTURY_TOKEN + 'C' + century
    }

    return year + month + day.toString().split('').reverse().join('') + century
  },

  numberSplit: function (inputDate) {
    var splitInputDate = inputDate.toString().replace(' ', '').split('')
    var result = []
    var resultIndex = 0

    for (var inputCount = 0; inputCount < splitInputDate.length; inputCount++) {
      if (splitInputDate[inputCount] === CENTURY_TOKEN) {
        result[resultIndex] = splitInputDate.splice(inputCount + 1).join('')
        continue
      }

      result[resultIndex] = splitInputDate[inputCount]
      var nextInputChar = splitInputDate[inputCount + 1]
      if (nextInputChar) {
        inputCount = inputCount + 1
        if (nextInputChar === CENTURY_TOKEN) {
          result[resultIndex + 1] = splitInputDate.splice(inputCount + 1).join('')
        } else {
          result[resultIndex] += nextInputChar
        }
      }
      resultIndex = resultIndex + 1
    }
    return result
  },

  getMajor: function (inputNumbers) {
    const majorSystem = ['O', 'A', 'B', 'C', 'D', 'E', 'S', 'G', 'H', 'N']
    var outputString = ''
    inputNumbers.toString().split('').forEach(function (e) {
      outputString += majorSystem[e] || ' '
    })
    return outputString
  },

  get: function (inputDate) {
    return this.numberSplit(this.date(inputDate))
  }
}



// WEBPACK FOOTER //
// ./src/lib/dateFormat.js